<template>
  <div class="app-container">
    <div class="page-header">
      <h2>企业入驻审核</h2>
    </div>

    <div class="search-bar">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="申请状态" clearable @change="fetchData">
            <el-option label="待审核" value="PENDING"></el-option>
            <el-option label="已通过" value="APPROVED"></el-option>
            <el-option label="已拒绝" value="REJECTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="searchForm.keyword" placeholder="搜索公司/法人/手机号" clearable @clear="fetchData"
            @keyup.enter.native="fetchData">
            <el-button slot="append" icon="el-icon-search" @click="fetchData"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column prop="companyName" label="公司名称" min-width="150"></el-table-column>
      <el-table-column prop="creditCode" label="统一社会信用代码" width="180"></el-table-column>
      <el-table-column prop="legalPerson" label="法人代表" width="100"></el-table-column>
      <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
      <el-table-column label="营业执照" width="120">
        <template slot-scope="scope">
          <el-image 
            style="width: 50px; height: 50px"
            :src="$http.getFullImageUrl(scope.row.licenseUrl)" 
            :preview-src-list="[$http.getFullImageUrl(scope.row.licenseUrl)]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="160">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'PENDING'">
            <el-button type="text" size="small" @click="handleAudit(scope.row, true)">通过</el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleAudit(scope.row, false)">拒绝</el-button>
          </div>
          <el-button v-else type="text" size="small" disabled>已处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 审核弹窗 -->
    <el-dialog :title="auditDialog.title" :visible.sync="auditDialog.visible" width="50%">
      <el-form :model="auditDialog.form" label-width="100px">
        <!-- 申请详情展示 -->
        <div v-if="auditDialog.currentRow" class="detail-section">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司名称">{{ auditDialog.currentRow.companyName }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一信用代码">{{ auditDialog.currentRow.creditCode }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法人姓名">{{ auditDialog.currentRow.legalPerson }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">{{ auditDialog.currentRow.phone }}</el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="法人身份证">{{ auditDialog.currentRow.legalPersonIdCard }}</el-form-item>
          <el-form-item label="经营范围">{{ auditDialog.currentRow.businessScope }}</el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="营业执照">
                 <el-image 
                  style="width: 100px; height: 100px"
                  :src="$http.getFullImageUrl(auditDialog.currentRow.licenseUrl)" 
                  :preview-src-list="[$http.getFullImageUrl(auditDialog.currentRow.licenseUrl)]">
                </el-image>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证正面">
                 <el-image 
                  style="width: 100px; height: 60px"
                  :src="$http.getFullImageUrl(auditDialog.currentRow.idCardFrontUrl)" 
                  :preview-src-list="[$http.getFullImageUrl(auditDialog.currentRow.idCardFrontUrl)]">
                </el-image>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证反面">
                 <el-image 
                  style="width: 100px; height: 60px"
                  :src="$http.getFullImageUrl(auditDialog.currentRow.idCardBackUrl)" 
                  :preview-src-list="[$http.getFullImageUrl(auditDialog.currentRow.idCardBackUrl)]">
                </el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>

        <el-form-item label="审核备注">
          <el-input type="textarea" v-model="auditDialog.form.remark" placeholder="请输入审核备注（选填）"></el-input>
        </el-form-item>
        <div v-if="auditDialog.approved" class="audit-info">
          <p><i class="el-icon-info"></i> 通过审核后将自动创建以下账号：</p>
          <p>账号：{{ auditDialog.currentRow ? auditDialog.currentRow.phone : '' }}</p>
          <p>初始密码：123456</p>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditDialog.loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApplicationAudit',
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        status: 'PENDING',
        keyword: ''
      },
      auditDialog: {
        visible: false,
        title: '',
        loading: false,
        approved: false,
        currentRow: null,
        form: {
          remark: ''
        }
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await this.$http.get('/enterprise/applications', {
          params: this.searchForm
        })
        if (response.success) {
          this.tableData = response.data
        }
      } catch (error) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    
    getStatusType(status) {
      const map = {
        'PENDING': 'warning',
        'APPROVED': 'success',
        'REJECTED': 'danger'
      }
      return map[status] || 'info'
    },
    
    getStatusLabel(status) {
      const map = {
        'PENDING': '待审核',
        'APPROVED': '已通过',
        'REJECTED': '已拒绝'
      }
      return map[status] || status
    },
    
    formatDate(dateStr) {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleString()
    },
    
    handleAudit(row, approved) {
      this.auditDialog.currentRow = row
      this.auditDialog.approved = approved
      this.auditDialog.title = approved ? '通过申请' : '拒绝申请'
      this.auditDialog.form.remark = ''
      this.auditDialog.visible = true
    },
    
    async submitAudit() {
      this.auditDialog.loading = true
      try {
        const { currentRow, approved, form } = this.auditDialog
        const response = await this.$http.post(`/enterprise/applications/${currentRow.id}/audit`, {
          approved: approved,
          auditRemark: form.remark
        })
        
        if (response.success) {
          this.$message.success('操作成功')
          this.auditDialog.visible = false
          this.fetchData()
        }
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message 
          ? error.response.data.message 
          : '未知错误'
        this.$message.error('操作失败: ' + message)
      } finally {
        this.auditDialog.loading = false
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}
.page-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.audit-info {
  background: #f0f9eb;
  padding: 10px;
  border-radius: 4px;
  color: #67c23a;
  margin-top: 10px;
}
</style>
